
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { BAIconsMixin } from '@/mixins';
import { participantNoteOn, participantRsvpOn } from '@/helpers/availability';
import { CalendarEventModel } from '@/models/calendar/CalendarEventModel';
import { CalendarEventsApi } from '@/api/CalendarApi';
import { CalendarEventParticipant } from '@/../types/interfaces';

@Component
export default class EventRsvpControl extends Mixins(BAIconsMixin) {
	@Prop({ required: true }) event: CalendarEventModel;
	@Prop({ required: true }) calendarEventsApi: CalendarEventsApi;
	@Prop({ required: true }) profileId: string;
	/** YYYY-MM-DD for one date of a repeating event; undefined answers the whole series. */
	@Prop({ default: undefined }) occurrenceDate: string | undefined;

	selected: string = 'None';
	note: string = '';
	showNote: boolean = false;
	saving: boolean = false;
	saved: boolean = false;
	error: boolean = false;

	created(): void {
		this.loadMyAnswer();
	}

	/** Re-read when the viewer moves to another date of a repeating event. */
	@Watch('occurrenceDate')
	onOccurrenceDateChanged(): void {
		this.loadMyAnswer();
	}

	private loadMyAnswer(): void {
		const p = this.MyParticipant;
		if (p) {
			this.selected = participantRsvpOn(p, this.occurrenceDate) || 'None';
			this.note = participantNoteOn(p, this.occurrenceDate);
			if (this.note) this.showNote = true;
		}
	}

	get MyParticipant(): CalendarEventParticipant | undefined {
		return (this.event.participants || []).find(p => p.athleteId === this.profileId || p.coachId === this.profileId);
	}
	get ArrivalLabel(): string {
		if (!this.event.arrivalTime) return '';
		return new Date(this.event.arrivalTime).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
	}

	/** v-btn-toggle clears the model when the active button is clicked again. */
	async onChange(): Promise<void> {
		if (!this.selected) this.selected = 'None';
		await this.save();
	}

	async save(): Promise<void> {
		if (!this.MyParticipant) return;
		this.saving = true; this.saved = false; this.error = false;
		try {
			const updated = await this.calendarEventsApi.setRsvp(this.event.id, this.selected, this.note, this.occurrenceDate);
			this.$emit('updated', updated);
			this.saved = true;
			setTimeout(() => (this.saved = false), 2500);
		} catch (e) {
			this.error = true;
			// eslint-disable-next-line no-console
			console.error('Failed to save RSVP', e);
		} finally {
			this.saving = false;
		}
	}
}
